<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Bahnübergänge verwalten' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript://" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times"/>
      </a>
    </div>
  </header>
  <div class="h-60 scroll-y padding-10 d-f col">
    <div id="picContainer">
      <div class="btn-group btn-icon margin-6-t">
        <button class="btn btn-primary" [title]="'Neu' | mrTranslate" (click)="initBue()">
          <cds-icon shape="file" />
        </button>
        <button
          class="btn btn-outline"
          [title]="'Export' | mrTranslate"
          (click)="createExcelDoc()"
          [disabled]="!canCreateExcelDoc()">
          <cds-icon shape="excel"/>
        </button>
      </div>
      @if (bueMap().sa) {
        <clr-datagrid class="datagrid-compact" [style.grid-area]="'dg'">
          <clr-dg-column [clrDgField]="'bezeichnung'">
            <ng-container *clrDgHideableColumn="{ hidden: false }">{{ 'Bezeichnung' | mrTranslate }}</ng-container>
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'Quadrant1_2'">
            <ng-container *clrDgHideableColumn="{ hidden: false }">{{ 'Quadrant' | mrTranslate }} 1 + 2</ng-container>
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'Quadrant3_4'">
            <ng-container *clrDgHideableColumn="{ hidden: false }">{{ 'Quadrant' | mrTranslate }} 3 + 4</ng-container>
          </clr-dg-column>
          <clr-dg-row [clrDgItem]="bueMap().bersa">
            <clr-dg-cell class="name-cell">{{ 'Berechnung' | mrTranslate }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().bersa.Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().bersa.Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-row [clrDgItem]="bueMap().vstmin">
            <clr-dg-cell class="name-cell">Vst {{ 'Min' | mrTranslate }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().vstmin.Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().vstmin.Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-row [clrDgItem]="bueMap().vstmax">
            <clr-dg-cell class="name-cell">Vst {{ 'Max' | mrTranslate }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().vstmax.Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().vstmax.Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-row [clrDgItem]="bueMap().ve">
            <clr-dg-cell class="name-cell">Ve</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().ve.Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().ve.Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-row [clrDgItem]="bueMap().d">
            <clr-dg-cell class="name-cell">d</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().d.Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ bueMap().d.Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
          <clr-dg-row [clrDgItem]="calculatedSA()">
            <clr-dg-cell class="name-cell">sa</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ calculatedSA().Quadrant1_2 }}</clr-dg-cell>
            <clr-dg-cell class="name-cell">{{ calculatedSA().Quadrant3_4 }}</clr-dg-cell>
          </clr-dg-row>
        </clr-datagrid>
      } @else if (isLoadingBue()) {
        <clr-spinner class="centred" />
      }

      <label [style.grid-area]="'min'">vst {{ 'Min' | mrTranslate }}</label>
      <label [style.grid-area]="'max'">vst {{ 'Max' | mrTranslate }}</label>

      <label [style.grid-area]="'Q1'">{{ 'Quadrant' | mrTranslate }} I</label>
      <label [style.grid-area]="'Q2'">{{ 'Quadrant' | mrTranslate }} II</label>
      <label [style.grid-area]="'Q3'">{{ 'Quadrant' | mrTranslate }} III</label>
      <label [style.grid-area]="'Q4'">{{ 'Quadrant' | mrTranslate }} IV</label>

      @for (bild of bilder(); track $index) {
        <div class="bildContainer" [style.grid-area]="'p' + $index">
          <div class="d-f clr-justify-content-between">
            <div class="btn-group btn-icon">
              <button type="button" class="btn" (click)="selIndex.set($index); isCameraOpen.set(true)">
                <cds-icon shape="camera" />
              </button>
              <button type="button" class="btn" (click)="selIndex.set($index); fileInput.click()">
                <cds-icon shape="upload-cloud" />
              </button>
            </div>
            @if (bild) {
              <button type="button" class="btn btn-icon btn-danger nm" (click)="deleteBILDBue($index)">
                <cds-icon shape="times-circle" />
              </button>
            }
          </div>
          @if (bild) {
            <img class="" (click)="bildData.set(bild); isBildModalOpen.set(true)" [src]="bild" />
          } @else if (selIndex() == $index && isLoadingBild()) {
            <clr-spinner class="centred" />
          }
        </div>
      }
    </div>

    <input
      type="file"
      #fileInput
      id="fileInput"
      name="fileInput"
      accept="image/*"
      hidden
      multiple
      (change)="onFileChange($event)" />
  </div>
</div>

<clr-modal [clrModalOpen]="showSVGModal()" (clrModalOpenChange)="showSVGModal.set($event)" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ 'Berechnung nach BÜV NE' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="d-f clr-justify-content-between clr-form-horizontal padding-6-lr">
      <clr-radio-container clrInline class="nym">
        <label>{{ 'Bereich' | mrTranslate }}</label>
        <clr-radio-wrapper>
          <input type="radio" clrRadio [(ngModel)]="selQuadrant" [value]="0" />
          <label>{{ 'Quadrant 1+2' | mrTranslate }}</label>
        </clr-radio-wrapper>
        <clr-radio-wrapper>
          <input type="radio" clrRadio [(ngModel)]="selQuadrant" [value]="1" />
          <label>{{ 'Quadrant 3+4' | mrTranslate }}</label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <button type="submit" form="form-quadrant" class="btn btn-success nm">
        {{ 'Speichern' | mrTranslate }}
      </button>
    </div>
    <form
      id="form-quadrant"
      clrForm
      class="width100 w-100-p"
      [clrLayout]="'horizontal'"
      [clrLabelSize]="5"
      [formGroup]="formQuadrant"
      (ngSubmit)="saveBue()">
      <div class="clr-row">
        <clr-select-container class="clr-col-auto">
          <label>{{ 'Berechnung' | mrTranslate }}:</label>
          <select clrSelect formControlName="bersa">
            <option value="Kraftfahrzeug">{{ 'Kraftfahrzeug' | mrTranslate }}</option>
            <option value="Fußgänger">{{ 'Fußgänger' | mrTranslate }}</option>
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
        <clr-select-container class="clr-col-auto">
          <label>VSt (km/h) Min</label>
          <select clrSelect formControlName="vstmin">
            @switch (formQuadrant.value.bersa) {
              @case ('Fußgänger') {
                <option [ngValue]="1.4">1,4</option>
                <option [ngValue]="1">1</option>
              }
              @case ('Kraftfahrzeug') {
                <option [ngValue]="10">10</option>
                <option [ngValue]="5">5</option>
              }
            }
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
        <clr-select-container class="clr-col">
          @switch (formQuadrant.value.bersa) {
            @case ('Fußgänger') {
              <label>VSt (m/s)</label>
            }
            @case ('Kraftfahrzeug') {
              <label>VSt (km/h)</label>
            }
          }
          <select clrSelect formControlName="vstmax">
            @switch (formQuadrant.value.bersa) {
              @case ('Fußgänger') {
                <option [ngValue]="1.4">1,4</option>
                <option [ngValue]="1">1</option>
              }
              @case ('Kraftfahrzeug') {
                <option [ngValue]="50">50 u. 40</option>
                <option [ngValue]="30">30</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="10">10</option>
                <option [ngValue]="5">5</option>
              }
            }
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
        <clr-select-container class="clr-col">
          <label>VE (km/h)</label>
          <select clrSelect formControlName="ve">
            <option [ngValue]="5">5</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="15">15</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="30">30</option>
            <option [ngValue]="40">40</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="60">60</option>
            <option [ngValue]="70">70</option>
            <option [ngValue]="80">80</option>
          </select>
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-select-container>
      </div>
      <div id="svg-container">
        <img src="assets/icons/BUE_Cal_n.svg" class="mw-100-p light" style="margin-top: 10px" />
        <clr-number-input-container id="d-input" class="nm">
          <label class="clr-col-12" hidden>d</label>
          <input type="number" clrNumberInput formControlName="d" class="clr-col-12" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
          @if (formQuadrant.controls.d.errors?.min; as err) {
            <clr-control-error>{{ 'Min' | mrTranslate }} {{ err.min }}</clr-control-error>
          }
        </clr-number-input-container>

        <input id="sa-input" type="text" formControlName="sa" readonly="true" />
      </div>
    </form>
  </div>

  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="showSVGModal.set(false)">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div> -->
</clr-modal>

@if (isCameraOpen()) {
  <app-camera [(showWebcam)]="isCameraOpen" (takenFoto)="onTakenFoto($event)" [allowVideo]="false" />
}

@if (isBildModalOpen()) {
  <clr-modal
    [clrModalOpen]="isBildModalOpen()"
    (clrModalOpenChange)="isBildModalOpen.set(false)"
    [clrModalSize]="'lg'"
    [clrModalStaticBackdrop]="false">
    <div class="modal-body full-height d-f col clr-justify-content-center">
      <img class="mw-100-p h-auto centred" [src]="bildData()" />
    </div>
  </clr-modal>
}
